import {UserRole} from "../types/UserRole.enum";

export const roleText = {
  [UserRole.PUBLIC]: 'Public',
  [UserRole.ADMIN]: 'Admin',
  [UserRole.SUPER_ADMIN]: 'Super Admin'
}
